import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import {
  deleteReq,
  patch,
  useGet,
  usePatch,
  usePost,
} from "src/http-clients/clients";
import { getUserRole } from "src/redux/selectors/app";

export const useCreateStore = () => {
  const userRole = useSelector(getUserRole);
  return usePost(
    userRole === 1
      ? "/super-admin/stores/create-store"
      : "/users/stores/create-store"
  );
};

export const useGetStores = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/super-admin/stores/stores-list${queryData}`);
  return data;
};

export const useGetStoreData = (storeId: number) => {
  return useGet(storeId ? `/super-admin/stores/store/${storeId}` : null);
};

export const useUpdateStore = (storeId: number) => {
  return usePatch(`/super-admin/stores/store/${storeId}`);
};

export const useUpdateStoreStatus = () => {
  const handleStatusChange = useCallback((storeId: number, status: boolean) => {
    return patch(`/super-admin/stores/store/${storeId}`, { status });
  }, []);
  return useFetchAsync(handleStatusChange);
};

export const useDeleteStore = () => {
  const deleteData = useCallback((storeId: number) => {
    return deleteReq(`/super-admin/stores/store/${storeId}`);
  }, []);
  return useFetchAsync(deleteData);
};
